import React from 'react';
import { Grid } from '@material-ui/core';
import { css } from '@emotion/react';
import { H3 } from './blocks';
import { COLUMNS } from './constants';

const Header = ({ backgroundColor = 'white' }) => {
    return (
        <Grid
            container
            direction="row"
            css={css`
                border-bottom: 1px solid lightgrey;
                padding: 20px 20px;
                background-color: ${backgroundColor};
                flex-wrap: nowrap;
            `}
        >
            <Grid
                container
                direction="column"
                css={css`
                    flex: 0 0 36px;
                    max-width: 36px;
                    margin-right: 12px;
                `}
            />
            {COLUMNS.map(({ key, label, width, align }, idx) => {
                const isLast = idx === COLUMNS.length - 1;
                const isFirst = idx === 0;
                return (
                    <Grid
                        key={key}
                        container
                        direction="column"
                        css={css`
                            flex: ${width ? width : 1};
                            flex-basis: 0;
                            ${isFirst ? 'margin-right: 12px;' : isLast ? 'margin-left: 12px;' : 'margin: 0 12px;'}
                            align-content: ${align === 'left'
                                ? 'flex-start'
                                : align === 'right'
                                ? 'flex-end'
                                : 'center'};
                        `}
                    >
                        <H3>{label}</H3>
                    </Grid>
                );
            })}
        </Grid>
    );
};

export default Header;
